var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    xmlns: "http://www.w3.org/2000/svg",
    height: 43,
    id: "screenshot-2bd33f28-acce-8023-8007-4569cada19b3",
    viewBox: "0 0 43 43",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b3"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-2bd33f28-acce-8023-8007-4569cada19b3-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-2bd33f28-acce-8023-8007-4569cada19b3-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19b3"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b4",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b5",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19b5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.25,
    height: 42.25,
    x: -0.4082299216224783,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: -0.04487239495392714
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b6"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "rgb(0, 0, 0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b7",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1617431640625,31.93511962890625C35.3316650390625,33.22515869140625,34.2818603515625,34.255126953125,34.0518798828125,34.51513671875C33.7318115234375,34.83514404296875,32.5616455078125,35.46514892578125,31.6016845703125,34.51513671875L24.2117919921875,27.2451171875C24.8817138671875,26.81512451171875,25.0018310546875,26.775146484375,25.6217041015625,26.20513916015625C26.2418212890625,25.6351318359375,26.2518310546875,25.01513671875,26.6317138671875,24.30511474609375L34.1717529296875,31.93511962890625Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(120, 120, 120)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19b9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6116943359375,11.95513916015625C21.6317138671875,8.01513671875,15.1617431640625,8.01513671875,11.1817626953125,11.95513916015625C7.2017822265625,15.8951416015625,7.2017822265625,22.30511474609375,11.1817626953125,26.2451171875C15.1617431640625,30.18511962890625,21.6317138671875,30.18511962890625,25.6116943359375,26.2451171875C29.5916748046875,22.30511474609375,29.6417236328125,15.8951416015625,25.6116943359375,11.95513916015625Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(152, 152, 152)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19ba"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0518798828125,31.56512451171875C13.7218017578125,31.56512451171875,14.2518310546875,32.08514404296875,14.2518310546875,32.755126953125C14.2518310546875,33.42510986328125,13.7218017578125,33.94512939453125,13.0518798828125,33.94512939453125C12.3817138671875,33.94512939453125,11.8516845703125,33.42510986328125,11.8516845703125,32.755126953125C11.8516845703125,32.08514404296875,12.3817138671875,31.56512451171875,13.0518798828125,31.56512451171875Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-0a0f6cfd-6150-8025-8007-4677e2000658-2bd33f28-acce-8023-8007-4569cada19ba",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0518798828125,31.56512451171875C13.7218017578125,31.56512451171875,14.2518310546875,32.08514404296875,14.2518310546875,32.755126953125C14.2518310546875,33.42510986328125,13.7218017578125,33.94512939453125,13.0518798828125,33.94512939453125C12.3817138671875,33.94512939453125,11.8516845703125,33.42510986328125,11.8516845703125,32.755126953125C11.8516845703125,32.08514404296875,12.3817138671875,31.56512451171875,13.0518798828125,31.56512451171875Z",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(255, 144, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19bb"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2318115234375,17.60516357421875C33.0418701171875,17.60516357421875,33.7218017578125,18.26513671875,33.7218017578125,19.07513427734375C33.7218017578125,19.8851318359375,33.0518798828125,20.545166015625,32.2318115234375,20.545166015625C31.4117431640625,20.545166015625,30.7418212890625,19.8851318359375,30.7418212890625,19.07513427734375C30.7418212890625,18.26513671875,31.4117431640625,17.60516357421875,32.2318115234375,17.60516357421875Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-0a0f6cfd-6150-8025-8007-4677e2011e81-2bd33f28-acce-8023-8007-4569cada19bb",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2318115234375,17.60516357421875C33.0418701171875,17.60516357421875,33.7218017578125,18.26513671875,33.7218017578125,19.07513427734375C33.7218017578125,19.8851318359375,33.0518798828125,20.545166015625,32.2318115234375,20.545166015625C31.4117431640625,20.545166015625,30.7418212890625,19.8851318359375,30.7418212890625,19.07513427734375C30.7418212890625,18.26513671875,31.4117431640625,17.60516357421875,32.2318115234375,17.60516357421875Z",
    style: {
      fill: "none",
      strokeWidth: 0.75,
      stroke: "rgb(255, 144, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada19bc"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada19bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0218505859375,13.53515625C27.1417236328125,16.6251220703125,27.1417236328125,21.59515380859375,24.0218505859375,24.6251220703125C20.9017333984375,27.71514892578125,15.8817138671875,27.71514892578125,12.8216552734375,24.6251220703125C9.7618408203125,21.53515625,9.7017822265625,16.56512451171875,12.8216552734375,13.53515625C15.9417724609375,10.44512939453125,20.9617919921875,10.44512939453125,24.0218505859375,13.53515625Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7633"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1217041015625,26.32513427734375C34.4617919921875,26.32513427734375,34.7418212890625,26.60516357421875,34.7418212890625,26.94512939453125C34.7418212890625,27.28515625,34.4517822265625,27.56512451171875,34.1217041015625,27.56512451171875C33.7918701171875,27.56512451171875,33.5018310546875,27.28515625,33.5018310546875,26.94512939453125C33.5018310546875,26.60516357421875,33.7918701171875,26.32513427734375,34.1217041015625,26.32513427734375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7634"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7634"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4217529296875,26.32513427734375C6.7618408203125,26.32513427734375,7.0418701171875,26.60516357421875,7.0418701171875,26.94512939453125C7.0418701171875,27.28515625,6.7518310546875,27.56512451171875,6.4217529296875,27.56512451171875C6.0916748046875,27.56512451171875,5.8018798828125,27.28515625,5.8018798828125,26.94512939453125C5.8018798828125,26.60516357421875,6.0916748046875,26.32513427734375,6.4217529296875,26.32513427734375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7635"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3616943359375,6.025146484375C26.7818603515625,6.025146484375,27.1417236328125,6.3851318359375,27.1417236328125,6.795166015625C27.1417236328125,7.20513916015625,26.7818603515625,7.56512451171875,26.3616943359375,7.56512451171875C25.9417724609375,7.56512451171875,25.5816650390625,7.20513916015625,25.5816650390625,6.795166015625C25.5816650390625,6.3851318359375,25.9417724609375,6.025146484375,26.3616943359375,6.025146484375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(244, 140, 78)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7636"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7636"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7017822265625,12.525146484375C35.0418701171875,12.525146484375,35.3216552734375,12.80511474609375,35.3216552734375,13.1451416015625C35.3216552734375,13.48516845703125,35.0318603515625,13.76513671875,34.7017822265625,13.76513671875C34.3717041015625,13.76513671875,34.0816650390625,13.48516845703125,34.0816650390625,13.1451416015625C34.1317138671875,12.81512451171875,34.3717041015625,12.525146484375,34.7017822265625,12.525146484375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(120, 120, 120)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7637"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7637"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4117431640625,33.32513427734375C24.7518310546875,33.32513427734375,25.0318603515625,33.60516357421875,25.0318603515625,33.94512939453125C25.0318603515625,34.28515625,24.7418212890625,34.56512451171875,24.4117431640625,34.56512451171875C24.0816650390625,34.56512451171875,23.7918701171875,34.28515625,23.7918701171875,33.94512939453125C23.8416748046875,33.6151123046875,24.0816650390625,33.32513427734375,24.4117431640625,33.32513427734375Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(228, 126, 63)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7638"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7638"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6217041015625,30.94512939453125C19.9617919921875,30.94512939453125,20.2418212890625,31.22515869140625,20.2418212890625,31.56512451171875C20.2418212890625,31.9051513671875,19.9517822265625,32.18511962890625,19.6217041015625,32.18511962890625C19.2918701171875,32.18511962890625,19.0018310546875,31.9051513671875,19.0018310546875,31.56512451171875C19.0518798828125,31.23516845703125,19.2918701171875,30.94512939453125,19.6217041015625,30.94512939453125Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(195, 195, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2bd33f28-acce-8023-8007-4569cada7639"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2bd33f28-acce-8023-8007-4569cada7639"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.711770078377413,
    cy: 21.075127605046077,
    rx: 20.86999999999989,
    ry: 20.870000000000005,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-0a0f6cfd-6150-8025-8007-4677e20347d8-2bd33f28-acce-8023-8007-4569cada7639",
    className: "strokes",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.711770078377413,
    cy: 21.075127605046077,
    rx: 20.86999999999989,
    ry: 20.870000000000005,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      strokeWidth: 0.5,
      stroke: "rgb(244, 140, 78)",
      strokeOpacity: 1
    }
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.f14e67a9544ae6bf5f84dfde89253a0b.svg";
export { ForwardRef as ReactComponent };